var render = function render(){var _vm=this,_c=_vm._self._c;return _c('trax-ui-ajax-table-with-crud-actions',{attrs:{"id":_vm.id,"edit":false,"delete":_vm.allowedToDelete,"titles":_vm.titles,"props":_vm.props,"endpoint":_vm.endpoint,"endpoint-params":_vm.endpointParams,"bus":_vm.bus}})
}
var staticRenderFns = []

export { render, staticRenderFns }